import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
// import App from './TrailCases/DropDown'
// import App from './TrailCases/App'
import './index.css'

import { transitions, positions, Provider as AlertProvider } from 'react-alert'
import AlertTemplate from 'react-alert-template-basic'

// Axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
// Axios.defaults.xsrfCookieName = "csrftoken";
// Axios.defaults.withCredentials = true;


// function App() {

//   function sayHello() {
//     alert('Hello!');
//   }
  
//   return (
//     <button onClick={sayHello}>
//       Click me!
//     </button>
//   );
// }

// export default App;
// optional cofiguration
const options = {
    // you can also just use 'bottom center'
    position: positions.BOTTOM_CENTER,
    timeout: 5000,
    offset: '30px',
    // you can also just use 'scale'
    transition: transitions.SCALE
  }
  
  const Root = () => (
    <AlertProvider template={AlertTemplate} {...options}>
      <App />
    </AlertProvider>
  )

ReactDOM.render(
    <Root />,
    document.getElementById('root')
);